module.exports = __webpack_public_path__ + "media/images/clip-img-4765f0bf8cf8715f5f310cd3b4a78d5a.png";